import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HammerModule } from '@angular/platform-browser';
import { SharedModule } from '../../shared/shared.module';
import { ChatComponent } from './chat.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { MessageService } from './services/message.service';
import { CarouselComponent } from './shared/components/carousel/carousel.component';
import { TelInputDirective } from './tel-input/tel-input.directive';
import { TextareaAutoExpandDirective } from './textarea-auto-expand.directive';

@NgModule({
  imports: [CommonModule, FormsModule, SharedModule, HammerModule],
  declarations: [ChatComponent, FileUploadComponent, TextareaAutoExpandDirective, TelInputDirective, CarouselComponent],
  exports: [ChatComponent],
  providers: [MessageService, DatePipe],
})
export class ChatModule {}
